import Logo from "../assets/images/error.svg";
import {Button} from "reactstrap";
import {useNavigate} from 'react-router-dom'


function PageNotFound() {
    const navigate = useNavigate()

    return (
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <div className="card">

                            <div className="card-body p-4">

                                <div className="error-ghost text-center">
                                    {/*<img src="assets/images/error.svg" width="200" alt="error-image"/>*/}
                                    <img
                                        src={Logo}
                                        width="200"
                                        alt={Logo}/>
                                </div>

                                <div className="text-center">
                                    <h3 className="mt-4 text-uppercase font-weight-bold">Page not found </h3>
                                    <p className="text-muted mb-0 mt-3">It's looking like you
                                        may have taken a wrong turn. Don't worry...
                                        it happens to the best of us. You might want to check your internet connection.
                                        Here's a little tip that might help you get back on track.</p>

                                    <Button type="button"
                                            onClick={() => navigate("/")}
                                            className="btn bx-btn-primary mt-3"
                                    >
                                        <i className="mdi mdi-reply mr-1"/>
                                        Return Dashboard
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageNotFound;